import { SelectionModel } from '@angular/cdk/collections';
import { Injectable } from '@angular/core';

@Injectable()
export class ManagePermissionSelectionService {
  selection = new SelectionModel<string>(true);
  indeterminate = new SelectionModel<string>(true);
  initSelection = new SelectionModel<string>(true);
  initIndeterminate = new SelectionModel<string>(true);

  updateSelection(emails: string[], indeterminate: string[]) {
    this.selection.clear();
    this.indeterminate.clear();
    this.initSelection.clear();
    this.initIndeterminate.clear();
    this.selection.select(...emails);
    this.initSelection.select(...emails);
    this.indeterminate.select(...indeterminate);
    this.initIndeterminate.select(...indeterminate);
  }

  toggleCheckbox(email: string) {
    this.selection.toggle(email);
    this.indeterminate.deselect(email);
  }

  deselectAll() {
    this.selection.clear();
    this.indeterminate.clear();
  }

  isSelected(email: string): boolean {
    return this.selection.isSelected(email);
  }

  isIndeterminate(email: string): boolean {
    return this.indeterminate.isSelected(email);
  }

  isChecklistUpdated() {
    if (
      this.initSelection.selected.length !== this.selection.selected.length ||
      this.initIndeterminate.selected.length !== this.indeterminate.selected.length
    )
      return true;
    if (this.getDeleted().length > 0) return true;
    return this.getAdded().length > 0;
  }

  getDeleted(): string[] {
    return this.initSelection.selected.filter((email) => !this.selection.isSelected(email));
  }

  getAdded(): string[] {
    return this.selection.selected.filter(
      (email) =>
        !this.initSelection.isSelected(email) ||
        (this.initIndeterminate.isSelected(email) && !this.indeterminate.isSelected(email)),
    );
  }
}
